import dagangNet from "@/assets/LandingPage/logo.png";
// import dnex from "@/assets/UniLogo/dnex.jpg";
// import hamzanwadi from "@/assets/UniLogo/hamzanwadi.png";
// import ihm from "@/assets/UniLogo/IHM.jpeg";
// import kcom from "@/assets/UniLogo/kcom.jpg";
// import LuxTagTest from "@/assets/UniLogo/LuxTagTest.png";
// import mataram from "@/assets/UniLogo/mataram.png";
// import muhammadiyah from "@/assets/UniLogo/muhammadiyah.jpg";
// import stikes from "@/assets/UniLogo/stikesntb.jpeg";
// import stkip_tsbima from "@/assets/UniLogo/stkip_tsbima.png";
// import trans from "@/assets/UniLogo/trans.jpg";
// import u45m from "@/assets/UniLogo/u45m.png";
// import UniXYZ from "@/assets/UniLogo/UniXYZ.png";
// import unsa from "@/assets/UniLogo/unsa.png";
// import nuuntb from "@/assets/UniLogo/ununtb.jpeg";
// import utsntb from "@/assets/UniLogo/utsntb.png";

export default {
  dagangNet,
  // dnex,
  // hamzanwadi,
  // ihm,
  // kcom,
  // LuxTagTest,
  // mataram,
  // muhammadiyah,
  // nuuntb,
  // stikes,
  // stkip_tsbima,
  // trans,
  // u45m,
  // UniXYZ,
  // unsa,
  // utsntb
};



// WEBPACK FOOTER //
// ./src/assets/js/logoMapping.js